/* eslint-disable */

/** All built-in and custom scalars, mapped to their actual values */

export const CreateTenantAnonymousDocument = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "CreateTenantAnonymous"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "tenant"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "CreateTenantInput"
          }
        }
      }
    }],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "createTenantAnonymous"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "tenant"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "tenant"
            }
          }
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "name"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "locale"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "logo"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "plan"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "mfa"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "createdAt"
            }
          }]
        }
      }]
    }
  }]
};
export const CreateUsersDocument = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "CreateUsers"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "userNames"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "ListType",
          "type": {
            "kind": "NonNullType",
            "type": {
              "kind": "NamedType",
              "name": {
                "kind": "Name",
                "value": "String"
              }
            }
          }
        }
      }
    }],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "createUsers"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "userNames"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "userNames"
            }
          }
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "firstName"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "lastName"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "fullName"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "email"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "username"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "createdAt"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "onboarded"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "enabled"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "role"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "teams"
            }
          }]
        }
      }]
    }
  }]
};
export const DeleteUserDocument = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "DeleteUser"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "userId"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "String"
          }
        }
      }
    }],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "deleteUser"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "userId"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "userId"
            }
          }
        }]
      }]
    }
  }]
};
export const GetMeDocument = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "GetMe"
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "getMe"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "firstName"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "lastName"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "fullName"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "email"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "username"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "createdAt"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "onboarded"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "enabled"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "role"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "teams"
            }
          }]
        }
      }]
    }
  }]
};
export const GetTenantDocument = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "GetTenant"
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "getTenant"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "createdAt"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "logo"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "locale"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "mfa"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "name"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "onboarded"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "plan"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "paymentStatus"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "shouldSelectPlan"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "shouldSetupPayments"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "paymentsEnabled"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "provider"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
};
export const GetTenantAnonymousDocument = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "GetTenantAnonymous"
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "getTenantAnonymous"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "locale"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "name"
            }
          }]
        }
      }]
    }
  }]
};
export const ListUserRolesDocument = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "ListUserRoles"
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "listUserRoles"
        }
      }]
    }
  }]
};
export const ListUsersDocument = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "ListUsers"
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "listUsers"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "firstName"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "lastName"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "fullName"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "email"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "username"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "createdAt"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "onboarded"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "enabled"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "role"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "teams"
            }
          }]
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "getTenant"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "mfa"
            }
          }]
        }
      }]
    }
  }]
};
export const SendPasswordResetLinkDocument = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "SendPasswordResetLink"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "userId"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "String"
          }
        }
      }
    }],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "sendPasswordResetLink"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "userId"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "userId"
            }
          }
        }]
      }]
    }
  }]
};
export const UpdateMeDocument = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "UpdateMe"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "user"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "MeInput"
          }
        }
      }
    }],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "updateMe"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "user"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "user"
            }
          }
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "firstName"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "lastName"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "fullName"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "email"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "username"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "createdAt"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "onboarded"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "enabled"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "role"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "teams"
            }
          }]
        }
      }]
    }
  }]
};
export const UpdateTenantDocument = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "UpdateTenant"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "tenant"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "TenantInput"
          }
        }
      }
    }],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "updateTenant"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "tenant"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "tenant"
            }
          }
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "createdAt"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "logo"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "locale"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "mfa"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "name"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "plan"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "paymentStatus"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "shouldSelectPlan"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "shouldSetupPayments"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "paymentsEnabled"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "provider"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
};
export const UpdateUserDocument = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "UpdateUser"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "user"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "UserInput"
          }
        }
      }
    }],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "updateUser"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "user"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "user"
            }
          }
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "firstName"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "lastName"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "fullName"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "email"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "username"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "createdAt"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "onboarded"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "enabled"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "role"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "teams"
            }
          }]
        }
      }]
    }
  }]
};
export const GetPaymentOptionsAnonymousDocument = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "GetPaymentOptionsAnonymous"
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "getPaymentOptionsAnonymous"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "plans"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "name"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "key"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "description"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "trial"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "trialDays"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "prices"
                },
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "amount"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "currency"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "recurrenceInterval"
                    }
                  }]
                }
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "taxes"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "name"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "countryCode"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "percentage"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
};
export const GetTenantPaymentDetailsDocument = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "GetTenantPaymentDetails"
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "getTenantPaymentDetails"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "status"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "shouldSelectPlan"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "shouldSetupPayments"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "paymentsEnabled"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "provider"
                }
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "details"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "plan"
                },
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "id"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "name"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "key"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "description"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "trial"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "trialDays"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "prices"
                    },
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "amount"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "currency"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "recurrenceInterval"
                        }
                      }]
                    }
                  }]
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "price"
                },
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "amount"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "currency"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "recurrenceInterval"
                    }
                  }]
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "trial"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "trialDaysLeft"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
};
export const SetTenantPlanDetailsDocument = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "SetTenantPlanDetails"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "details"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "SetTenantPlanDetailsInput"
          }
        }
      }
    }],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "setTenantPlanDetails"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "details"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "details"
            }
          }
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "status"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "shouldSelectPlan"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "shouldSetupPayments"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "paymentsEnabled"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "provider"
                }
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "details"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "plan"
                },
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "id"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "name"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "key"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "description"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "trial"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "trialDays"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "prices"
                    },
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "amount"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "currency"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "recurrenceInterval"
                        }
                      }]
                    }
                  }]
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "price"
                },
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "amount"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "currency"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "recurrenceInterval"
                    }
                  }]
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "trial"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "trialDaysLeft"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
};
export const GetAppAnonymousDocument = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "GetAppAnonymous"
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "getAppAnonymous"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "name"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "logo"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "privacyPolicyUrl"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "termsOfServiceUrl"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "onboardingFlow"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "passkeysEnabled"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "azureAdSsoEnabled"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "googleSsoEnabled"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "linkedinSsoEnabled"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "facebookSsoEnabled"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "githubSsoEnabled"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "appleSsoEnabled"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "mfaEnabled"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "magicLinkEnabled"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "tenantSelfSignup"
            }
          }]
        }
      }]
    }
  }]
};